const isEmailValid = (value: string) => {
  const EMAIL_REGEXP = /^([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)$/iu;
  return EMAIL_REGEXP.test(String(value).toLowerCase());
};
export default isEmailValid;
